module.exports = __webpack_public_path__ + "img/logo_微信小程序.3512e42c.png";